import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { ReactNode } from "react";
import DynamicFontSize from "../DynamicFontSize";
interface ValueGroupCenterPropsType extends GeneralPropsType {
  field?: string;
  value?: ReactNode;
  des?: ReactNode;
  unit?: ReactNode;
}
function ValueGroupCenter({
  field,
  value,
  des,
  unit,
  className
}: ValueGroupCenterPropsType) {
  return <div className={clsx("flex flex-col gap-0.5 items-center", styles.container, className)} data-sentry-component="ValueGroupCenter" data-sentry-source-file="index.tsx">
            <div className={styles.field}>{field}</div>
            <DynamicFontSize fontSize={28} className="text-secondary flex items-center font-semibold " data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                {unit}
                {value}
            </DynamicFontSize>
            <div className={styles.des}>{des}</div>
        </div>;
}
export default ValueGroupCenter;